import React, { useEffect, useState, useRef } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import { templateDataCollection, templateDataCourse } from '../../data'
import { patchCourseLandingPageAction } from 'src/reducers/course/action'
import { patchCollectionLandingPageAction } from 'src/reducers/collection/action'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

const TemplateSelect = props => {
  const {
    classes,
    pageUrl,
    setHtmlContent,
    setSelectedTemplateId,
    setSelectedFont,
  } = props
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [currentPage, setCurrentPage] = useState(0)
  const TEMPLATES_PER_PAGE = 5
  const { id, page, subPage } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const templateContainerRef = useRef(null)

  const activeTemplateData =
    pageUrl === 'mini-course' ? templateDataCourse : templateDataCollection
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  // Create a safe version of landingPageData with fallback to empty object
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings || {} : collectionSettings || {}

  const course = useSelector(state => state.course.course)

  const totalPages = Math.ceil(activeTemplateData.length / TEMPLATES_PER_PAGE)

  const visibleTemplates = activeTemplateData.slice(
    currentPage * TEMPLATES_PER_PAGE,
    (currentPage + 1) * TEMPLATES_PER_PAGE,
  )

  useEffect(() => {
    if (landingPageData.initialized !== true) {
      setSelectedTemplate(0)
    }
    const handleScroll = () => {
      if (templateContainerRef.current) {
        const templateRect = templateContainerRef.current.getBoundingClientRect()
        setIsButtonVisible(templateRect.bottom < 0)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (templateContainerRef.current) {
      templateContainerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    }
  }, [currentPage])

  const handleTemplateClick = template => {
    setSelectedTemplate(template.id)

    if (setSelectedTemplateId) {
      setSelectedTemplateId(template.id)
      setSelectedFont(template.font)
    }

    if (setHtmlContent && template.value) {
      if (typeof template.value === 'object') {
        const htmlContent = template.value[1].content.html
        if (landingPageData?.metadata !== null && template.id === 0) {
          const landingPageSection = landingPageData?.sections.find(
            x => x.type === 'Header',
          )
          Array.from(
            document.getElementsByClassName('editor-header-container'),
          ).forEach(element => {
            element.style.background = `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), 
            url(${landingPageSection.content.image}) lightgray 50% / cover no-repeat`
          })
        } else {
          Array.from(
            document.getElementsByClassName('editor-header-container'),
          ).forEach(element => {
            element.style.background = `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), 
            url(${template.value[0].content.image}) lightgray 50% / cover no-repeat`
          })
        }

        const editorElement = document.getElementsByClassName(
          'course-container-header-text',
        )[0]
        const editorElementStartButton = document.getElementsByClassName(
          'start-button-text-header',
        )[0]
        const editorHeaderContent = document.getElementsByClassName(
          'editor-header-content',
        )[0]
        const editorElementStartButton2 = document.getElementsByClassName(
          'start-button',
        )[0]

        if (editorElement) {
          if (
            template.id === 2 ||
            template.id === 9 ||
            template.id === 13 ||
            template.id === 14
          ) {
            editorHeaderContent.style.setProperty(
              'text-align',
              'left',
              'important',
            )
            editorHeaderContent.style.setProperty(
              'align-items',
              'flex-start',
              'important',
            )
          } else {
            editorHeaderContent.style.setProperty(
              'text-align',
              'center',
              'important',
            )
            editorHeaderContent.style.setProperty(
              'align-items',
              'center',
              'important',
            )
          }
          editorElement.style.setProperty(
            'font-family',
            template.font,
            'important',
          )
          if (pageUrl === 'mini-course') {
            editorElementStartButton.style.setProperty(
              'font-family',
              template.font,
              'important',
            )
            editorElementStartButton.style.setProperty(
              'color',
              template.primaryColor,
              'important',
            )
            editorElementStartButton2.style.setProperty(
              'font-family',
              template.font,
              'important',
            )
            editorElementStartButton2.style.setProperty(
              'background',
              template.primaryColor,
              'important',
            )
          }
        }
        setHtmlContent(htmlContent)
      } else {
        setHtmlContent(template.value[1].content.html)
        Array.from(
          document.getElementsByClassName('editor-header-container'),
        ).forEach(element => {
          element.style.background = `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), 
          url(${template.value[0].content.image}) lightgray 50% / cover no-repeat`
        })
      }
    }
  }

  const handleApplyPreset = () => {
    if (selectedTemplate === null) {
      return
    }

    const patchAction =
      pageUrl === 'mini-course'
        ? patchCourseLandingPageAction
        : patchCollectionLandingPageAction

    const selectedTemplateObject =
      pageUrl === 'mini-course'
        ? templateDataCourse.find(template => template.id === selectedTemplate)
        : templateDataCollection.find(
            template => template.id === selectedTemplate,
          )

    if (!selectedTemplateObject) return

    // Dispatch the save action
    dispatch(
      patchAction(id, [
        {
          path: 'initialized',
          value: true,
        },
        {
          path: 'primaryColor',
          value: selectedTemplateObject.primaryColor,
        },
        {
          path: 'font',
          value: selectedTemplateObject.font,
        },
        {
          path: 'sections',
          value: selectedTemplateObject.value,
        },
      ]),
    )
  }

  const closeApplyPreset = () => {
    const patchAction =
      pageUrl === 'mini-course'
        ? patchCourseLandingPageAction
        : patchCollectionLandingPageAction

    dispatch(
      patchAction(id, [
        {
          path: 'initialized',
          value: true,
        },
      ]),
    )
  }

  const handleStartBlank = () => {
    setSelectedTemplate(null)

    if (setSelectedTemplateId) {
      setSelectedTemplateId(null)
      setSelectedFont('Inter')
    }

    if (setHtmlContent) {
      setHtmlContent('')
    }
  }

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const goToNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1)
    }
  }

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <div className={classes.headerContainer}>
          <Icon
            icon={'mdi:cards-outline'}
            className={classes.icons}
            fontSize={16}
          />
          <Typography className={classes.headerText}>
            Get started with a preset
          </Typography>
        </div>
        <div className={classes.close} onClick={handleStartBlank}>
          <Icon
            color="#002E47"
            icon="iconamoon:close-light"
            className={classes.icon}
            onClick={() => closeApplyPreset()}
          />
        </div>
      </div>

      <div className={classes.templateWrapper}>
        {/* Şablonlar */}
        <div className={classes.template} ref={templateContainerRef}>
          {visibleTemplates.map(template => (
            <div
              key={template.id}
              className={`${classes.column} ${
                selectedTemplate === template.id ? classes.selectedTemplate : ''
              }`}
              style={
                selectedTemplate === template.id
                  ? { border: '1px solid var(--mcg-blue, #015FFB)' }
                  : {}
              }
              onClick={() => handleTemplateClick(template)}
            >
              <div
                className={classes.cardTop}
                style={{
                  background: `url(${template.thumbnail}) lightgray 50% / cover no-repeat`,
                }}
              ></div>
              <div className={classes.cardHeader}>
                <Typography className={classes.cardText}>
                  {template.name}
                </Typography>
              </div>
            </div>
          ))}

          <div
            className={`${classes.navButton} ${classes.navButtonLeft} ${
              currentPage === 0 ? classes.navButtonDisabled : ''
            }`}
            onClick={goToPreviousPage}
          >
            <Icon
              icon={'mdi:chevron-left'}
              className={classes.navIcon}
              fontSize={24}
            />
          </div>

          <div
            className={`${classes.navButton} ${classes.navButtonRight} ${
              currentPage >= totalPages - 1 ? classes.navButtonDisabled : ''
            }`}
            onClick={goToNextPage}
          >
            <Icon
              icon={'mdi:chevron-right'}
              className={classes.navIcon}
              fontSize={24}
            />
          </div>
        </div>
      </div>

      <div className={classes.applyButtonContainer}>
        <div
          className={`${classes.applyButton} ${
            isButtonVisible ? classes.applyButtonVisible : ''
          }`}
        >
          <CoreButton
            size="small"
            color="primary"
            variant={isButtonVisible ? 'contained' : 'outlined'}
            onClick={() => handleApplyPreset()}
            disabled={selectedTemplate === null}
          >
            Apply this preset
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(TemplateSelect)
